import React, { useState, useEffect } from "react";
import cc_format from "@/func/card_formatter";
import valid from "card-validator";
import icon from "@/public/fallbacks/lock-3.svg";

const CardField = ({
  dataTestId,
  placeholder,
  error,
  name,
  type,
  width,
  value,
  margin,
  max,
  setValue,
  submitCount,
  register,
  trigger,
}) => {
  function formatInputValue(name, value) {
    if (name == "card_number") {
      return cc_format(value);
    }
  }
  const [isValidationActive, setIsValidationActive] = useState(false);
  const [creditCardType, setCardType] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const isEnhancedContrast = window.enhancedContrast;

  useEffect(() => {
    const cardData = valid.number(value);
    if (cardData?.card?.type) {
      setCardType(cardData?.card?.type);
    } else {
      setCardType(null);
    }
  }, [value]);

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginInlineEnd: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div
        className={`input input--text ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && error && "enhancedContrast__error"}`}
      >
        <input
          data-testid={dataTestId}
          maxLength={max}
          className="styledInput"
          autoComplete="cc-number"
          type={type}
          name={name}
          {...register(name)}
          value={formatInputValue(name, value)}
          onFocus={() => {
            setIsFocused(true);
          }}
          onChange={(e) => {
            setValue(name, formatInputValue(name, e.target.value), {
              shouldValidate: isValidationActive,
              shouldTouch: true,
            });
          }}
          //
        />
        <label
          className={`styledLabel ${value.length > 0 ? "styledLabel--active" : ""} ${isEnhancedContrast && "styledLabel__enhancedContrast"}`}
        >
          {placeholder}
        </label>
        <div
          className="input__img"
          style={{
            width: creditCardType ? "24px" : "16px",
            height: creditCardType ? "24px" : "16px",
            backgroundSize: "contain",
            backgroundImage: `url(${
              creditCardType ? window.template_root + "checkout-V4/src/public/cards/" + creditCardType + ".svg" : icon
            })`,
          }}
        ></div>
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default CardField;
